import {getCurrentYear} from '../../utils/commons'
import BestReviewsLogo from './logo'
import {bestReviewsStyles} from './styles'

const baseConfig = {
  domainName: 'intbestreviews' as const,
  domainType: 'brg' as const,
  camelCaseUrl: 'BestReviews.guide',
  siteName: 'Best Reviews Guide',
  logo: <BestReviewsLogo />,
  favicon: '/favicons/bestreviews.png',
  styles: bestReviewsStyles,
}

const localeConfigs = {
  us: {
    measurementId: 'G-48QBP4TDQ9',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in the US | There's One Clear Winner | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analyzes thousands of articles and customer reviews to find the top-rated products at today's lowest prices. Best products, best offers.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
